/* eslint-disable */
import React, { Fragment } from 'react';
import './home.scss';
import PlaceholderMap from './../../assets/map2.svg';
import PlaceholderChart from './../../assets/chartPlaceholderL6.svg';

const HomeGoogle = () => {
  return (
    <Fragment>
      <div className="mainWrapper pageHome">
        <header class="appHeader">
          <div class="headerContent">
            <h2>
              <span class="featured">10N</span> ELECCIONES GENERALES 2019
            </h2>
          </div>
        </header>
        <div className="colContainer">
          <div className="floatingBlock left">
            <div className="inner">
              <div className="mapSelectorContainer">
                <div className="buttonsContainer">
                  <button type="button" class="button current">
                    Congreso
                  </button>
                  <button type="button" class="button undefined">
                    Senado
                  </button>
                </div>
                <div className="mapContainer">
                  <div className="selectsContainer">
                    <div role="presentation" class="select">
                      <div class="selectLabel">
                        <span class="selectLabelTxt">Seleccione comunidad</span>
                      </div>
                      <ul class="selectItems"></ul>
                    </div>
                    <div role="presentation" class="select">
                      <div class="selectLabel">
                        <span class="selectLabelTxt">Seleccione provincia</span>
                      </div>
                      <ul class="selectItems"></ul>
                    </div>
                  </div>
                  <div className="mapWrapper">
                    <img
                      src={PlaceholderMap}
                      className="map mapa-svg"
                      alt="Mapa de España"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="floatingBlock right">
            <div className="inner">
              <div class="cardBlock graphContainer">
                <div class="cardBlockHeader">
                  <h2 class="cardBlockTitle">
                    ESCRUTADO:<span class="cardBlockTitleSecondary">0%</span>
                  </h2>
                  <span class="cardBlockSubtitle cardBlockSubtitle__indicator">
                    Actualizado a las: "00:00"
                  </span>
                </div>
                <div class="cardBlockContent">
                  <img
                    src={PlaceholderChart}
                    class="recharts-surface"
                    alt="Gráfico de barras"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="floatingBlock right">
            <div className="inner">
              <div class="tabsContainer">
                <section class="titles">
                  <div class="title current">Datos</div>
                  <div class="title">2016</div>
                  <div class="title">Pactómetro</div>
                </section>
                <div class="content">
                  <div class="table-datosContainer">
                    <div class="table-datosScroll">
                      <div class="table-wrapper">
                        <table summary="Escaños por partido.">
                          <thead>
                            <tr>
                              <th class="partido">Partido</th>
                              <th class="escanos">Escaños</th>
                              <th class="porcentaje">%</th>
                              <th class="votos">Votos</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="dato-nombre-partido">
                                <span>
                                  <span class="partido">Partido 1</span>
                                </span>
                              </td>
                              <td class="dato-escanos">123</td>
                              <td class="dato-escanos">10</td>
                              <td class="dato-escanos_votes">1.000.000</td>
                            </tr>
                            <tr>
                              <td class="dato-nombre-partido">
                                <span>
                                  <span class="partido">Partido 2</span>
                                </span>
                              </td>
                              <td class="dato-escanos">123</td>
                              <td class="dato-escanos">10</td>
                              <td class="dato-escanos_votes">1.000.000</td>
                            </tr>
                            <tr>
                              <td class="dato-nombre-partido">
                                <span>
                                  <span class="partido">Partido 3</span>
                                </span>
                              </td>
                              <td class="dato-escanos">123</td>
                              <td class="dato-escanos">10</td>
                              <td class="dato-escanos_votes">1.000.000</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p class="table-datosLegend">
                      *UNIDAS PODEMOS: Podemos - IU - Equo - En Comú PODEM - En
                      Común Podemos
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="floatingBlock left">
            <div className="inner">
              <div class="cardBlock undefined">
                <div class="cardBlockHeader">
                  <h2 class="cardBlockTitle">
                    Principales ciudades de
                    <span class="cardBlockTitleSecondary">España</span>
                  </h2>
                </div>
                <div class="cardBlockContent">
                  <div class="selectsContainer CityTagsselectsContainer">
                    <div role="presentation" class="select">
                      <div class="selectLabel">
                        <span class="selectLabelTxt">Seleccione localidad</span>
                      </div>
                      <ul class="selectItems"></ul>
                    </div>
                    <div class="autocomplete showarrow ">
                      <input
                        type="text"
                        autocomplete="nope"
                        placeholder="Escribe una localidad"
                        value=""
                      />
                    </div>
                  </div>
                  <div class="tags">
                    <a class="tag" href="#">
                      Ciudad 1
                    </a>
                    <a class="tag" href="#">
                      Ciudad 2
                    </a>
                    <a class="tag" href="#">
                      Ciudad 3
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomeGoogle;
